/**
 * Pure gate for WHEN the push-permission prime may fire after a saved pick.
 *
 * The WC→Arena onboarding snackbar fires on a brand-new user's FIRST saved pick.
 * To avoid stacking the push prompt on top of it, brand-new users (who have not
 * yet seen the onboarding bridge) are deferred to their SECOND save — by then the
 * once-per-lifetime onboarding has already shown and won't compete. Established
 * users (bridge already seen before this session) get primed on the first save.
 *
 * `bridgeSeenAtMount` is a snapshot read at mount, BEFORE any pick this session,
 * which is what keeps this decision race-free against the onboarding manager
 * (that manager flips the persisted flag while showing the snackbar). `null`
 * means the snapshot has not resolved yet — treated as brand-new (conservative).
 */

export function pushPrimeRequiredSavedCount(bridgeSeenAtMount: boolean | null): number {
  return bridgeSeenAtMount === true ? 1 : 2;
}

export function shouldAttemptPushPrime(params: {
  savedCount: number;
  bridgeSeenAtMount: boolean | null;
}): boolean {
  if (params.savedCount === 0) return false;
  return params.savedCount >= pushPrimeRequiredSavedCount(params.bridgeSeenAtMount);
}
